/** Default clip-reveal easing for cartesian charts. */
export const DEFAULT_ANIMATION_EASING = "cubic-bezier(0.85, 0, 0.15, 1)";

export const DEFAULT_ANIMATION_DURATION_MS = 1100;

/**
 * Easing for the paths that must stay tweens no matter what the enter
 * transition is — the clip-path reveal and the marker fade (see below).
 * Kept as its own constant so those paths still have an explicit curve now
 * that the enter transition is a spring and carries no `ease`.
 */
export const DEFAULT_CHART_REVEAL_EASE = [0.85, 0, 0.15, 1];

/**
 * Default enter transition: a DURATION-BASED spring, so elements that
 * animate a value (bars growing in, pie slices, terminal markers) settle
 * with a little overshoot instead of a flat ease.
 *
 * `duration` + `bounce` rather than stiffness/damping is deliberate —
 * callers and the shell override `duration` from the `animationDuration`
 * prop, and `clipRevealTransition` below reads `duration` to build its
 * tween. A physical spring has neither, which would silently reset both to
 * defaults.
 *
 * Values match bklit's own Spring preset (duration 1.1s, bounce 0.6) so the
 * charts move the way the library's showcase does.
 */
export const DEFAULT_CHART_ENTER_TRANSITION = {
  type: "spring",
  duration: DEFAULT_ANIMATION_DURATION_MS / 1000,
  bounce: 0.6,
};

/**
 * Clip-path width reveal must use tween — spring does not reliably animate SVG width.
 */
export function clipRevealTransition(enterTransition) {
  if (enterTransition?.type === "tween") {
    return {
      ...enterTransition,
      ease: enterTransition.ease ?? DEFAULT_CHART_REVEAL_EASE,
    };
  }

  const duration =
    typeof enterTransition?.duration === "number"
      ? enterTransition.duration
      : DEFAULT_ANIMATION_DURATION_MS / 1000;

  return {
    type: "tween",
    duration,
    ease: DEFAULT_CHART_REVEAL_EASE,
  };
}
